/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Box } from "theme-ui"

const Panel = ({ bg, color, space, children, className, sx }) => (
  <Box
    sx={{
      flexDirection: "column",
      py: space,
      bg,
      color,
      "&>h1,h2,h3,h4,h5,h6": {
        color,
      },
      ...sx,
    }}
    className={className}
  >
    {children}
  </Box>
)

Panel.defaultProps = {
  bg: "primary",
  color: "background",
  space: [4, 5, 6],
}

Panel.propTypes = {
  bg: PropTypes.string,
  color: PropTypes.string,
  space: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  children: PropTypes.any,
  className: PropTypes.string,
  sx: PropTypes.object,
}

export default Panel
